import { FC } from 'react';
import { OrderDetailHeaderTimerProps } from '../types';
import { BasicCircleButton } from 'shared/ui/buttons/iconButtons/circleButtons';
import { useOrderDetailHeaderTimer } from 'widgets/orderDetail/lib/hooks/useOrderDetailHeaderTimer';

export const OrderDetailHeaderTimer: FC<OrderDetailHeaderTimerProps> = ({
	order,
	variant,
}) => {
	const { hasTimer, timer, timerVariant } = useOrderDetailHeaderTimer(
		order,
		variant,
	);

	if (!hasTimer) {
		return null;
	}

	return (
		<BasicCircleButton variant={timerVariant}>{timer}</BasicCircleButton>
	);
};
